import { MobileAppDevelopments } from "./mobile-app-development";
import { OnDemandMobileAppDevelopments } from "./on-demand-mobile-app";
import { SoftwareDevelopments } from "./software-development";
import { WebsiteDevelopments } from "./website-development";

export const developmentServices = [
  ...MobileAppDevelopments,
  ...WebsiteDevelopments,
  ...SoftwareDevelopments,
  ...OnDemandMobileAppDevelopments,
];
